import {TransactionLine} from '../../src/types/transaction/TransactionLine'
import {TransactionLineCreationInfo} from '../../src/types/transaction/TransactionLineCreationInfo'

const weights = [3, 2, 7, 6, 5, 4, 3, 2]
const calculateControlDigit = (orgNo: number[]): number => {
    return 11 - (weights.reduce((acc, weight, index) => {
        acc += (weight * orgNo[index])
        return acc
    }, 0) % 11)
}
const getRandomOrgNo = (): string => {
    let orgNo = 10_000_000 + Math.floor(Math.random() * 89_999_999)
    let digitIndex = Math.floor(Math.random() * 7)
    let index = 0
    const orgNoDigits = String(orgNo).split('').map(Number)
    let controlDigit = calculateControlDigit(orgNoDigits)
    while (controlDigit <= 0 || controlDigit >= 10) {
        orgNoDigits[digitIndex] = (orgNoDigits[digitIndex] + 1) % 10
        index = (index + 1) % 10
        if (index === 0) {
            digitIndex = (digitIndex + 1) % 8
        }
        controlDigit = calculateControlDigit(orgNoDigits)
    }
    orgNoDigits[8] = controlDigit
    return orgNoDigits.join('')
}


const getRandomDocument = () => {

}

const getCurrentYear = (): string => {
    return (new Date().getFullYear()).toString()
}

const getCurrentDate = (): string => {
    const today = new Date()
    const day = today.getDate() < 10 ? '0' + today.getDate() : today.getDate()
    const month = (today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)
    const year = today.getFullYear()
    return `${day}-${month}-${year}`
}

const getLastYear = (): string => {
    const currentYear = new Date().getFullYear()
    return (currentYear - 1).toString()
}

const formatDateForTrialBalanceView = (date: string) => {
    if (!date || date.length === 0) return

    return date.split("-").reverse().join(".")
}

const tl = (account: string, amount: number, date: string = '', description: string = '', vatOptionId = 1): TransactionLineCreationInfo => {
    return {
        accountNo: account,
        amount,
        date,
        description: description,
        vatOptionId: vatOptionId,
        tags: [],
        subAccountLines: []
    }
}

enum USER {
    USER = 'DEMO_USER',
    USER1 = 'DEMO_USER1'
}

export {
    getRandomOrgNo,
    getRandomDocument,
    getCurrentYear,
    getCurrentDate,
    getLastYear,
    formatDateForTrialBalanceView,
    tl,
    USER
}